import { Navigate, Outlet } from "react-router-dom";
import Exception403 from "../pages/403";
import { useSelector } from "react-redux";

const PrivateRoute = ({ permissions }) => {
  const auth = useSelector((state) => state.auth);

  let accessAllowed = !permissions;
  if (
    auth.isLoggedIn &&
    auth.user?.roles &&
    permissions &&
    permissions.length > 0
  ) {
    permissions.forEach((perm) => {
      if (auth.user.roles.includes(perm)) {
        accessAllowed = true;
      }
    });
  }

  return auth.isLoggedIn && auth.user?.roles ? (
    accessAllowed === true ? (
      <Outlet />
    ) : (
      <Exception403 />
    )
  ) : (
    <Navigate to="/login" />
  );
};

export default PrivateRoute;
